export default __webpack_public_path__ + "static/media/1087.4aec63f9.png";